// extracted by mini-css-extract-plugin
export default {"formHeading":"eG-z","form":"fG-z","submitBtn":"gG-z","disabled":"hG-z","input":"iG-z","error":"jG-z","submitMsg":"kG-z","signIn":"lG-z"};